<script>

import { Overlay } from '../../'
import { PIVOT_LEVELS, pivotPeriodStart } from '../../workspace/pivot-points.mjs'

export default {
    name: 'PivotPoints',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Pivot Points Classic - Support and resistance levels',
                preset: {
                    name: 'Pivot Points',
                    side: 'onchart',
                    settings: {
                        lineWidth: 1,
                        pivotColor: '#ff9800',
                        supportColor: '#26a69a',
                        resistanceColor: '#ef5350'
                    }
                }
            }
        },
        draw(ctx) {
            const data=this.data,settings=this.settings,layout=this.layout;
            if(!data.length)return;
            const groups=[];
            for(const row of data){
                const key=pivotPeriodStart(row[0],settings.period||'Auto',Number(this.interval));
                if(groups.at(-1)?.key===key)groups.at(-1).end=row[0];
                else groups.push({key,start:row[0],end:row[0],values:row.slice(1)});
            }
            const plots=settings.$plotConfig?.outputs||[];
            const visible=groups.slice(-Math.min(200,Math.max(1,settings.pivotsBack||15)));
            ctx.save();ctx.font=this.font||'11px Arial';
            for(const group of visible)for(let i=0;i<PIVOT_LEVELS.length;i++){
                const level=PIVOT_LEVELS[i],plot=plots[i]||{},value=group.values[i];
                if(settings['show'+level]===false||plot.visible===false||!Number.isFinite(value))continue;
                const y=layout.$2screen(value),x1=layout.t2screen(group.start),x2=layout.t2screen(group.end+Number(this.interval));
                ctx.globalAlpha=(settings.$opacities?.[i]??settings.opacity??100)/100;
                ctx.strokeStyle=ctx.fillStyle=plot.color||(i===0?settings.pivotColor:level[0]==='S'?settings.supportColor:settings.resistanceColor)||'#ff9800';
                ctx.lineWidth=plot.width||settings.lineWidth||1;
                ctx.setLineDash(plot.style==='dashed'?[6,4]:plot.style==='dotted'?[2,3]:[]);
                ctx.beginPath();ctx.moveTo(x1,y);ctx.lineTo(x2,y);ctx.stroke();
                if(settings.showLabels!==false||settings.showPrices!==false){
                    const label=[settings.showLabels!==false?level:'',settings.showPrices!==false?value.toFixed(Number.isInteger(settings.precision)?settings.precision:2):''].filter(Boolean).join(' ');
                    const right=settings.labelPosition==='Right';ctx.textAlign=right?'right':'left';
                    ctx.fillText(label,right?x2-3:x1+3,y-3);
                }
            }
            ctx.restore();
        },
        use_for() { return ['PivotPoints'] },
        calc() {
            return {
                props: { period: { def: 'Day', text: 'Pivot Period (UTC)', type: 'select', choices: ['Day', 'Week', 'Month', 'Bar'] } },
                conf: { renderer: 'Splines' },
                update: `
                    let date = new Date(t)
                    let key = period === 'Month' ? date.getUTCFullYear() * 12 + date.getUTCMonth() : period === 'Week' ? Math.floor((t + 3 * 86400000) / 604800000) : period === 'Bar' ? t : Math.floor(t / 86400000)
                    let keys = ts(key), periodHigh = ts(NaN), periodLow = ts(NaN), periodClose = ts(close[0])
                    let previousHigh = ts(NaN), previousLow = ts(NaN), previousClose = ts(NaN)
                    let changed = keys[0] !== keys[1]
                    previousHigh[0] = changed ? periodHigh[1] : previousHigh[1]
                    previousLow[0] = changed ? periodLow[1] : previousLow[1]
                    previousClose[0] = changed ? periodClose[1] : previousClose[1]
                    periodHigh[0] = changed ? high[0] : Math.max(high[0], periodHigh[1])
                    periodLow[0] = changed ? low[0] : Math.min(low[0], periodLow[1])
                    let h = previousHigh[0], l = previousLow[0], c = previousClose[0]
                    let pivot = (h + l + c) / 3
                    return [pivot, 2 * pivot - l, pivot + h - l, h + 2 * (pivot - l), 2 * pivot - h, pivot - h + l, l - 2 * (h - pivot)]
                `
            }
        }
    }
}
</script>
